module.exports = __webpack_public_path__ + "assets/Cannerald_Shop_Icon-Pre-Roll.f69de35e.svg";